import { axios } from '@Root/API'

export const rejectContactUpdate = (id, data) => {
  return axios.post(`cognito-contact-updates/${id}/reject`, data)
}
